import { eraseCookies, getConfig, getCookie } from "vanilla-cookieconsent";

import { VccSection } from "core/types/cookies";

export const ANALYSIS_COOKIE_GROUP_PREFIX = "ANALYSIS_";

export const ON_COOKIE_CONSENT_EVENT_NAME = "onCookieConsent";

/**
 * Removes all cookies that the user has not consented to via vanilla-cookieconsent.
 */
export const removeUnconsentedCookies = () => {
    // An array of VCC category names that the user has consented to
    const consentedVccCategoryNames = getCookie("categories") ?? [];

    // Helper function to determine if a VCC section has been consented to
    const isVccSectionConsentedTo = (vccSection: VccSection) => {
        const categoryName = vccSection.linkedCategory;

        // False if the VCC section has no category
        if (!categoryName) return false;

        const vccCategory = (getConfig("categories") ?? [])[categoryName];

        // False if the section's VCC category does not exist
        if (!vccCategory) return false;

        // Returns true if...
        return (
            // The section's category is consented to, or...
            consentedVccCategoryNames.includes(categoryName) ||
            // The section's category is enabled by default and non-modifiable
            (vccCategory.enabled && vccCategory.readOnly)
        );
    }

    // TODO WRT-17819: We should resolve other translation configs
    const vccEnglishConfig = getConfig().language?.translations?.en;

    // TODO WRT-17820: We should resolve the other config types
    if (typeof vccEnglishConfig !== "object") return;

    // An array of the VCC config's sections, note that we assume it takes the form of our custom VccSection type
    const vccSections = vccEnglishConfig.preferencesModal.sections as VccSection[];
    // An array of all the cookies that the user has not consented to, as VCC cookie table rows
    const unconsentedVccCookieTableRows = vccSections
        .filter(vccSection => !isVccSectionConsentedTo(vccSection))
        .map(vccSection => vccSection.cookieTable?.body ?? [])
        .flat()
    ;

    // Remove all the unconsented cookies
    for (const { name, domain } of unconsentedVccCookieTableRows) {
        eraseCookies(name, "/", domain);
    }
}